//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CalendarioCard from './CalendarioCard';

export default {
  name: 'CalendarioToolbar',
  components: {
    CalendarioCard,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessView() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'CAL_VISUALIZAR').length;
    },
  },
  data() {
    return {
      menu: false,
    };
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/calendario/CalendarioToolbar.vue?vue&type=script&lang=js&